import type { ReactNode } from "react";

export function FullPageMessage({
  title,
  children,
  busy = false,
}: {
  title: string;
  children?: ReactNode;
  busy?: boolean;
}) {
  return (
    <main className="full-page">
      <div className="full-page-card" role={busy ? "status" : undefined}>
        {busy && <span className="spinner" aria-hidden="true" />}
        <h1>{title}</h1>
        {children}
      </div>
    </main>
  );
}
